import axiosInstance, { axiosInstanceImage } from "@helper/interceptor";

export const getAllTasks = async (params = {}) => {
  const {
    page = 1,
    pageSize = 100,
    search = "",
    project_id,
    without_project,
    ordering,
    measure_type,
    pruning_type,
    due_period,
    status,
    priority,
    area,
    assignee,
  } = params;
  const response = await axiosInstance.get("tasks/", {
    params: {
      page,
      page_size: pageSize,
      search,
      ...(project_id && { project_id }),
      ...(without_project && { without_project }),
      ...(ordering && { ordering }),
      ...(measure_type && { measure_type }),
      ...(pruning_type && { pruning_type }),
      ...(due_period && { due_period }),
      ...(status && { status }),
      ...(priority && { priority }),
      ...(area && { area }),
      ...(assignee && { assignee }),
    },
    timeout: 30000,
  });
  return response.data;
};

export const getTaskById = async (id) => {
  const response = await axiosInstance.get(`tasks/${id}/`);
  return response.data;
};

export const createTask = async (taskData) => {
  const response = await axiosInstance.post("tasks/", taskData);
  return response.data;
};

export const updateTask = async (taskData) => {
  const { id, ...payload } = taskData || {};
  const response = await axiosInstance.patch(`tasks/${id}/`, payload);
  return response.data;
};

export const deleteTask = async (id) => {
  const response = await axiosInstance.delete(`tasks/${id}/`);
  return response.data;
};

export const uploadTaskRegelkontrolleDocument = async (taskId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosInstanceImage.post(`tasks/${taskId}/upload-document/`, formData);
  return response.data;
};

export const getTaskSuggestions = async (params = {}) => {
  const response = await axiosInstance.get("task-suggestions/", { params });
  return response.data;
};

export const acceptTaskSuggestion = async ({ id, payload } = {}) => {
  const response = await axiosInstance.post(`task-suggestions/${id}/accept/`, payload || {});
  return response.data;
};

export const rejectTaskSuggestion = async (id) => {
  const response = await axiosInstance.post(`task-suggestions/${id}/reject/`);
  return response.data;
};
